module.exports = __webpack_public_path__ + "static/media/soils_example_2_3.4f185b2a.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_example_2_3.png
// module id = 1284
// module chunks = 0